var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapControl',{attrs:{"position":"top-left"}},[_c('Button',{attrs:{"type":"white","icon":_vm.icon,"title":_vm.title,"has-shadow":true},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }